import React from 'react'
import logo from 'assets/icons/logo.png'
import facebook from 'assets/icons/facebook.svg'
import instagram from 'assets/icons/instagram.svg'

function Clt() {
  // Centralize aqui para manter consistência
  const WHATS_NUMBER = '5543988288426'
  const WA_MSG_SIMULACAO = 'Olá, quero simular meu crédito consignado CLT.'
  const WA_URL = `https://wa.me/${WHATS_NUMBER}?text=${encodeURIComponent(WA_MSG_SIMULACAO)}`

  return (
    <main className='flex min-h-svh flex-col items-center overflow-x-hidden bg-gray-100 pt-28 sm:pt-32'>
      {/* Cabeçalho + Barra Superior */}
      <header className='fixed top-0 z-30 w-full shadow-lg'>
        <div className='flex flex-col bg-blue text-white'>
          <nav className='flex w-full flex-col items-center justify-between gap-3 p-3 px-4 sm:flex-row sm:gap-0 sm:p-4 sm:px-6 md:px-20'>
            <a
              href='https://lidercredsolucoes.com.br'
              className='shrink-0'
              aria-label='Ir para o site da Líder Cred'
              target='_blank'
              rel='noopener noreferrer'
            >
              <img src={logo} alt='Líder Cred - Soluções Financeiras' className='h-auto w-32 sm:w-40' loading='lazy' />
            </a>

            <h1 className='xs:text-2xl text-center text-xl font-semibold uppercase leading-snug text-yellow sm:text-right sm:text-3xl md:text-4xl'>
              Empréstimo Consignado 100% Online
            </h1>
          </nav>
        </div>
      </header>

      {/* Seção principal */}
      <section className='mb-40 mt-20 flex w-11/12 flex-col text-gray-700 md:w-8/12 lg:w-6/12'>
        <h2 className='text-2xl font-bold uppercase leading-tight text-blue sm:text-3xl md:text-5xl'>
          Faça seu consignado com segurança e rapidez
        </h2>

        <p className='mt-5 text-base leading-relaxed sm:mt-6 sm:text-lg'>
          A <strong>Líder Cred</strong> conecta você ao <strong>Consignado do Trabalhador (CLT)</strong> de forma
          <strong> 100% digital</strong>, <strong>sem burocracia</strong> e <strong>sem sair de casa</strong>. O
          desconto é feito diretamente na sua folha de pagamento e você conta com <strong>taxas reduzidas</strong> e
          <strong> mais poder de aprovação</strong>.
        </p>

        {/* Observação em vermelho */}
          <p className='mt-4 text-base font-semibold text-red-600 sm:text-lg'>
            ⚠️ Atendimento exclusivo para trabalhadores CLT com carteira assinada em empresas privadas. Não realizamos atendimento a autônomos, aposentados, pensionistas ou beneficiários do Bolsa Família.
          </p>

        {/* Texto acima do botão */}
        <p className='mt-6 text-base font-medium text-gray-800 sm:mt-8 sm:text-lg'>
          Clique abaixo e fale com um de nossos especialistas:
        </p>

        <a
          href={WA_URL}
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Falar com um especialista no WhatsApp'
          className='mt-3 inline-flex w-full items-center justify-center gap-2 rounded-md bg-[#25D366] px-6 py-4 text-lg font-semibold text-white transition hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-[#FFD400] focus:ring-offset-2 active:scale-[0.99] sm:mt-4 sm:w-auto sm:px-10 sm:py-5 sm:text-xl'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            fill='currentColor'
            viewBox='0 0 16 16'
            aria-hidden='true'
          >
            <path d='M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232' />
          </svg>
          <span>Quero uma Simulação</span>
        </a>
      </section>

      {/* Seção: O que é o Consignado do Trabalhador (CLT)? */}
      <section
        id='o-que-e'
        className='mb-14 w-11/12 max-w-screen-lg text-gray-700 md:w-8/12 lg:w-6/12'
        aria-labelledby='heading-o-que-e'
      >
        <h2 id='heading-o-que-e' className='text-2xl font-bold leading-tight text-blue sm:text-3xl md:text-4xl'>
          O que é o Consignado do Trabalhador (CLT)?
        </h2>

        <div className='mt-5 space-y-4 text-base leading-relaxed sm:mt-6 sm:text-lg'>
          <p>
            É um <strong>programa do Governo Federal</strong> que permite aos trabalhadores de{' '}
            <strong>empresas privadas</strong> contratarem <strong>empréstimos consignados</strong> com{' '}
            <strong>desconto em folha</strong>.
          </p>
          <p>
            O objetivo é <strong>facilitar o acesso ao crédito</strong> com{' '}
            <strong>condições financeiras melhores</strong>.
          </p>
          <p>
            O empréstimo possui <strong>margem consignável de 35%</strong> do salário, seguindo as regras vigentes e a
            política de crédito da instituição financeira.
          </p>
        </div>
      </section>

      {/* Seção: Vantagens */}
      <section
        id='vantagens'
        className='mb-14 w-11/12 max-w-screen-lg text-gray-700 md:w-8/12 lg:w-6/12'
        aria-labelledby='heading-vantagens'
      >
        <h2 id='heading-vantagens' className='text-2xl font-bold leading-tight text-blue sm:text-3xl md:text-4xl'>
          Vantagens
        </h2>

        <ul className='mt-6 grid gap-4 sm:gap-5'>
          <li className='rounded-xl border-2 border-gray-400 bg-white p-4 sm:p-5'>
            <strong>Desconto direto</strong> da parcela no salário do trabalhador.
          </li>
          <li className='rounded-xl border-2 border-gray-400 bg-white p-4 sm:p-5'>
            <strong>Taxas de juros reduzidas</strong> em comparação a outras linhas de crédito.
          </li>
          <li className='rounded-xl border-2 border-gray-400 bg-white p-4 sm:p-5'>
            Utiliza como <strong>garantia o saldo do FGTS</strong>, ajudando na aprovação.
          </li>
          <li className='rounded-xl border-2 border-gray-400 bg-white p-4 sm:p-5'>
            <strong>Processo digital e ágil</strong>, com atendimento humanizado.
          </li>
        </ul>
      </section>

      {/* Seção: Como Funciona? */}
      <section
        id='como-funciona'
        className='mb-20 w-11/12 max-w-screen-lg text-gray-700 md:w-8/12 lg:w-6/12'
        aria-labelledby='heading-como-funciona'
      >
        <h2 id='heading-como-funciona' className='text-2xl font-bold leading-tight text-blue sm:text-3xl md:text-4xl'>
          Como funciona?
        </h2>

        <ol className='mt-6 grid gap-4 sm:gap-5'>
          <li className='rounded-xl border-2 border-gray-400 bg-white p-4 sm:p-5'>
            <span className='mb-1 inline-flex h-7 w-7 items-center justify-center rounded-full bg-blue font-bold text-white'>
              1
            </span>
            <p className='mt-2 text-base leading-relaxed sm:text-lg'>
              Confirme seu <strong>vínculo CLT</strong> e nos envie as informações básicas para iniciar o processo.
            </p>
          </li>

          <li className='rounded-xl border-2 border-gray-400 bg-white p-4 sm:p-5'>
            <span className='mb-1 inline-flex h-7 w-7 items-center justify-center rounded-full bg-blue font-bold text-white'>
              2
            </span>
            <p className='mt-2 text-base leading-relaxed sm:text-lg'>
              Enviaremos um <strong>link gerado pelo banco parceiro</strong> para que você autorize a consulta dos seus
              dados e da empresa à qual está vinculado.
            </p>
          </li>

          <li className='rounded-xl border-2 border-gray-400 bg-white p-4 sm:p-5'>
            <span className='mb-1 inline-flex h-7 w-7 items-center justify-center rounded-full bg-blue font-bold text-white'>
              3
            </span>
            <p className='mt-2 text-base leading-relaxed sm:text-lg'>
              Após a autorização, é feita a <strong>simulação</strong> com as melhores opções disponíveis para o seu
              perfil.
            </p>
          </li>

          <li className='rounded-xl border-2 border-gray-400 bg-white p-4 sm:p-5'>
            <span className='mb-1 inline-flex h-7 w-7 items-center justify-center rounded-full bg-blue font-bold text-white'>
              4
            </span>
            <p className='mt-2 text-base leading-relaxed sm:text-lg'>
              Confirmando a proposta, o crédito é <strong>liberado diretamente na sua conta</strong> e as parcelas são
              descontadas em folha.
            </p>
          </li>
        </ol>

        {/* CTA secundário */}
        <div className='mt-8'>
          <a
            href={WA_URL}
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Simular crédito consignado CLT pelo WhatsApp'
            className='inline-flex w-full items-center justify-center gap-2 rounded-md bg-[#25D366] px-6 py-4 text-lg font-semibold text-white transition hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-[#FFD400] focus:ring-offset-2 active:scale-[0.99] sm:w-auto sm:px-10 sm:py-5 sm:text-xl'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              fill='currentColor'
              viewBox='0 0 16 16'
              aria-hidden='true'
            >
              <path d='M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.80.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232' />
            </svg>
            <span>Simular agora</span>
          </a>
        </div>
      </section>

      {/* Rodapé */}
      <footer className='w-full bg-blue text-white' id='contatos'>
        <div className='flex flex-col items-center justify-between'>
          <FAQSection WA_URL={WA_URL} />
          <ManualLinksSection />
          <CopyrightSection />
        </div>
      </footer>
    </main>
  )
}

function FAQSection({ WA_URL }) {
  return (
    <section className='mt-8 flex w-11/12 flex-col items-center justify-center gap-4 rounded-lg bg-white p-4 text-center md:w-9/12 md:p-10'>
      <header className='text-2xl font-bold text-blue md:text-5xl'>Ficou com alguma dúvida?</header>
      <p className='w-full text-lg text-gray-700 md:w-11/12 md:text-xl'>
        Converse com um dos nossos especialistas e tenha um atendimento especializado e humanizado.
      </p>
      <a
        href={WA_URL}
        target='_blank'
        rel='noopener noreferrer'
        className='rounded-lg bg-yellow px-6 py-3 text-base font-semibold uppercase text-black transition-opacity duration-500 hover:opacity-75 md:text-lg'
      >
        Fale com a nossa equipe
      </a>
    </section>
  )
}

function ManualLinksSection() {
  return (
    <section className='my-8 grid grid-cols-1 items-center justify-center gap-8 text-white md:w-9/12 md:grid-cols-2'>
      <div className='m-4 flex flex-col gap-8 md:flex-row'>
        <div className='flex flex-col gap-8'>
          <div className='flex flex-col gap-4'>
            <header className='text-2xl font-semibold'>Contato</header>
            <ul className='flex flex-col gap-2'>
              <li>
                <a
                  href='tel:4334840050'
                  className='transition-colors duration-200 hover:text-yellow'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  (43) 3484-0050
                </a>
              </li>
              <li>
                <a
                  href='https://api.whatsapp.com/send?phone=5543988288426&text=Ol%C3%A1%2C%20Vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20seus%20servi%C3%A7os.'
                  className='transition-colors duration-200 hover:text-yellow'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  (43) 98828-8426
                </a>
              </li>
              <li>
                <a
                  href='mailto:contato@lidercredsolucoes.com.br'
                  className='transition-colors duration-200 hover:text-yellow'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  contato@lidercredsolucoes.com.br
                </a>
              </li>
              <li>
                <a
                  href='https://maps.app.goo.gl/4L8CgKV7d9f9vwuY6'
                  className='transition-colors duration-200 hover:text-yellow'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Av. Castelo Branco, 920, Sala 07, Centro Comercial Cristal, Ivaiporã - PR, CEP 86870-000.
                </a>
              </li>
            </ul>
          </div>

          {/* Redes Sociais (desktop) */}
          <div className='hidden gap-2 md:flex md:items-center'>
            <a href='https://lidercredsolucoes.com.br' target='_blank' rel='noopener noreferrer'>
              <img src={logo} loading='lazy' alt='Líder Cred - Soluções Financeiras' className='w-44' />
            </a>

            <ul className='flex items-center gap-2 px-4'>
              <li>
                <a href='https://www.facebook.com/lidercredivp' target='_blank' rel='noopener noreferrer'>
                  <img
                    src={facebook}
                    alt='Facebook da Líder Cred'
                    className='h-16 w-16 transition-opacity duration-500 hover:opacity-75'
                  />
                </a>
              </li>
              <li>
                <a href='https://www.instagram.com/lidercredivp' target='_blank' rel='noopener noreferrer'>
                  <img
                    src={instagram}
                    alt='Instagram da Líder Cred'
                    className='h-16 w-16 transition-opacity duration-500 hover:opacity-75'
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Redes Sociais (mobile) */}
        <div className='flex gap-2 md:hidden md:items-center'>
          <a href='https://lidercredsolucoes.com.br' target='_blank' rel='noopener noreferrer'>
            <img src={logo} loading='lazy' alt='Líder Cred - Soluções Financeiras' className='w-44' />
          </a>

          <ul className='flex items-center gap-2 px-4'>
            <li>
              <a href='https://www.facebook.com/lidercredivp' target='_blank' rel='noopener noreferrer'>
                <img
                  src={facebook}
                  alt='Facebook da Líder Cred'
                  className='h-16 w-16 transition-opacity duration-500 hover:opacity-75'
                />
              </a>
            </li>
            <li>
              <a href='https://www.instagram.com/lidercredivp' target='_blank' rel='noopener noreferrer'>
                <img
                  src={instagram}
                  alt='Instagram da Líder Cred'
                  className='h-16 w-16 transition-opacity duration-500 hover:opacity-75'
                />
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Google Maps */}
      <div className='flex flex-col gap-4 md:items-center'>
        <iframe
          className='min-h-72 w-full'
          src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3638.0027924344317!2d-51.672886999999996!3d-24.241681099999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94eb5bfee14bc7e7%3A0x3ba7c1c5a3f61337!2sLidercred%20Emprestimos%20e%20Financiamentos!5e0!3m2!1sen!2sbr!4v1738843004479!5m2!1sen!2sbr'
          loading='lazy'
          allowFullScreen
          referrerPolicy='no-referrer-when-downgrade'
          title='Mapa - Líder Cred'
        />
      </div>
    </section>
  )
}

function CopyrightSection() {
  return (
    <div className='flex w-full items-center justify-center bg-white p-4'>
      <div className='flex flex-col gap-4 text-sm text-gray-700 md:w-10/12'>
        <a href='https://dorac.com.br' target='_blank' rel='noopener noreferrer'>
          © 2025 Líder Cred. Desenvolvido por Agência Dorac
        </a>

        <p className='text-xs leading-relaxed'>
          A Líder Cred não é uma instituição financeira e não realiza operações de crédito diretamente. A Líder Cred é
          uma plataforma digital que atua como correspondente bancário para facilitar o processo de contratação de
          empréstimos. Como correspondente bancário, seguimos as diretrizes do Banco Central do Brasil, nos termos da
          Resolução nº 3.954, de 24 de fevereiro de 2011. Toda avaliação de crédito será realizada conforme a política
          de crédito da Instituição Financeira escolhida pelo usuário. Antes da contratação de qualquer serviço através
          de nossos parceiros, você receberá todas as condições e informações relativas ao produto a ser contratado, de
          forma completa e transparente. As taxas de juros, margem consignável e prazo de pagamento praticados nos
          empréstimos com consignação em pagamento dos Governos Federais, Estaduais e Municipais, Forças Armadas e INSS
          observam as determinações de cada convênio, bem como a política de crédito da instituição financeira a ser
          utilizada. NASCIMENTO & PIANOWSKI LTDA — CNPJ 35.683.210/0001-06 Endereço: Av. Castelo Branco, 920, Sala 07,
          Centro Comercial Cristal, Ivaiporã - PR, CEP 86870-000.
        </p>
      </div>
    </div>
  )
}

export default Clt
